<template>
  <div class="contBox">
    <div class="chooseBox">
      <span>套用历史设置模板：</span>
        <el-select v-model="historySid" placeholder="请选择历史设置模板：" @change="onHsSelectChanged">
          <el-option
            v-for="item in historySdatas"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
    </div>


    <div class="chooseBox">
      <span>选择可见等级-筛选层级：</span>
      <el-radio-group v-model="showlevel" @input="onLevelChanged">
        <template v-for="option in levelOptions">
            <el-radio :label="option.id" :key="option.id">{{option.title}}</el-radio>
        </template>
      </el-radio-group>
    </div>
    <el-row class="w-40">
       <el-divider content-position="left" v-if="showlevel!=0">选择信息</el-divider>
    </el-row>

    <div class="block cascader" v-if="showlevel!=0">
      <div v-if="showPartyOptions">        
        <PartyOrgCascader ref="PartyOrgCascader" @onValueChanged="onPartyChanged"></PartyOrgCascader>        
      </div>      
      <div v-if="showUnitOptions">
        <UnitCascader ref="UnitCascader" @onValueChanged="onUnitValChanged"></UnitCascader>
      </div>
    </div>    

    <!-- 显示指定用户 -->
    <div v-if="showlevel == 3">
      <PersonCascader ref="PersonCascader" @onValueChanged="onPersonCascaderValueChanged"></PersonCascader>
    </div>

    <template v-if="isEdit">
      <div class="button_box">
        <el-button type="primary" @click="onClickUpdate">更新</el-button>
      </div>
    </template>
    <template v-else>
      <div class="button_box">
        <el-button @click="onClickPrevious">上一步</el-button>
        <el-button type="primary" @click="onClickNext">下一步</el-button>
      </div>
    </template>


  </div>
</template>

<script>
import {
  getAvailAbleSchedulingApi,
  getshowlevelbySid
} from "@/api/module/scheduling/scheduling";

import { getCompanyPeopleApi,getOrganPeopleApi } from "@/api/module/user/user"

import { schedulingEditInitApi,schedulingEditShowLevelApi } from "@/api/module/scheduling/scheduling"

import {
  PartyOrgCascader,
  UnitCascader,
  PersonCascader,
} from "@/views/components/select";

export default {
  name: "schedulinglocation",
  props:{
    timetype:{
      type: Number
    }
  },
  components: {
    PartyOrgCascader,UnitCascader,PersonCascader
  },
  data() {
    return {
      // edit scope
      id : null,
      loading : false,
      // edit scope end

      type : null,  // 排课的类型  0 默认 、1 学习班 、 2 单位课程  、 3 党组织生活
      studyClassType : null,  

      getParty: false,
      getUnit: false,

      showlevel: 0, // 0 全部， 1：单位 2：支部 3：个人

      bindUsers: [],    //  绑定的用户
      bindPartys: [],   //  绑定的支部
      bindUnits: [],    //  绑定的单位
 
      props: {
        multiple : true
      },

      loadingDatas : false,

      historyLoading : false,
      historySid : "",
      historySdatas : [],

      templateLoading : false,
      source : null,
      token: null,
      
      isjdx: null,
      isAdmin : null,
      roleid : null,

      formdata : {
        showlevel : null,
        bindUsers : null,
        bindPartys : null,
        bindUnits : null,
      },

    };
  },
  methods:{
    init() {

      // 初始化模版
      this.historyLoading = true;

      getAvailAbleSchedulingApi()
        .then((r)=>{
          console.log("getAvailAbleSchedulingApi",r);
          this.historySdatas = r;
          this.historyLoading = false;
        })

      // 初始化选择器
      // this.type = 3

      let id = this.$route.query.id;
      if(id){
        this.id = id;
        schedulingEditInitApi(id)
          .then((r)=>{
            // 初始化选中的
            console.log("schedulingEditInitApi",r)
            let mvo = r.schedulingTemplateMVO;
            this.applyMVOData(mvo);
    
          })
      }

    },

    setType(type){
      this.type = type;
    },

    onHsSelectChanged(data){
      this.$message.info("正在应用模板中，请稍后");

      console.log("onHsSelectChanged",data);

      if(this.templateLoading){
        return;
      }

      this.templateLoading = true;

      getshowlevelbySid(data)
        .then((res)=>{
          console.log("getshowlevelbySid",res);

          this.applyMVOData(res);
         
          this.$message.success("模板应用成功");
          this.templateLoading = false;
        })

    },

    applyMVOData(mvo){
      console.log("applyMVOData",mvo)
      let res = mvo;
      this.showlevel = res.showlevel;

      // 单位
      if(res.showlevel == 1){
        this.$nextTick(() => {

          if(!this.type){
            this.type = 1;
          }
          
          this.$refs.UnitCascader.initData(res.bindUnits);
          this.$refs.UnitCascader.initCascaderData(res.bindCascaderUnits);
          this.bindUnits = res.bindUnits;
        });
      }

      // 支部
      if(res.showlevel == 2){
        this.$nextTick(() => {
          // this.$refs.PartyOrgCascader.initData(res.bindPartys);
          if(!this.type){
            this.type = 2;
          }

          this.$refs.PartyOrgCascader.initCascaderData(res.bindCascaderPartys);

          // console.log(res.bindCascaderPartys);

          this.bindPartys = res.bindPartys;
        });
      }

      // 指定人员
      if(res.showlevel == 3){
        // 显示选择框
        this.$nextTick(() => {
          this.$refs.PersonCascader.initPersons(res.bindUsers,res.bindUserNames);
          this.bindUsers = res.bindUsers;
        });
      }
    },

    onLevelChanged(val){
      console.log("onLevelChanged",val)

      this.$nextTick(()=>{

        if(this.showPartyOptions){
          this.$refs.PartyOrgCascader.init();
        }

        if(this.showUnitOptions){
          this.$refs.UnitCascader.init();
        }

        if(this.showlevel == 3){
          this.$refs.PersonCascader.initbindUsers([])
        }

      })
    },



    onPartyChanged(val) {
      console.log("onPartyChanged",val)
      this.bindPartys = val;

      if(this.showlevel == 3){
        // 类型为人员时，初始化人员选择框
        this.loadingDatas = true;

        let data = {
          pids: val,
        };
        getOrganPeopleApi(data)
          .then((res) => {
            console.log("getOrganPeopleApi",res)
            this.$nextTick(() => {
              this.$refs.PersonCascader.initunbindUsers(res);
            });
          })
          .finally(() => {
            this.loadingDatas = false;
          });
      }
    },
    
    onPersonCascaderValueChanged(e) {
      this.bindUsers = e;
    },

    onUnitValChanged(e){
      console.log("onUnitValChanged",e)

      this.bindUnits = e;

      if(this.showlevel == 3){
        // 类型为人员时，初始化人员选择框
        this.loadingDatas = true;

        let data = {
          unitids: e,
        };
        getCompanyPeopleApi(data)
          .then((res) => {
            console.log("getCompanyPeopleApi",res)
            this.$nextTick(() => {
              this.$refs.PersonCascader.initunbindUsers(res);
            });
          })
          .finally(() => {
            this.loadingDatas = false;
          });
      }

    },

    onClickPrevious(){
      this.$emit("onClickPrevious");
    },

    onClickNext(){
      this.formdata.showlevel = this.showlevel
      this.formdata.bindUsers = this.bindUsers
      this.formdata.bindPartys = this.bindPartys
      this.formdata.bindUnits = this.bindUnits

      if(this.formdata.showlevel == null){
        this.$message.error("未选择可见类型")
        return;
      }

      if(this.formdata.showlevel == 1 && 
        (this.formdata.bindUnits.length == 0
          || !this.formdata.bindUnits
        )){
        this.$message.error("未选择单位");
        return;
      }

      if(this.formdata.showlevel == 2 && 
        (this.formdata.bindPartys.length == 0
          || !this.formdata.bindPartys
        )){
        this.$message.error("未选择单位信息");
        return;
      }

      if(this.formdata.showlevel == 3 && 
        (this.formdata.bindUsers.length == 0
          || !this.formdata.bindUsers
        )){
        this.$message.error("未选择人员信息");
        return;
      }

      console.log("this.formdata",this.formdata)

      this.$emit("onClickNext",this.formdata);
    },

    onClickUpdate(){

      this.loading = true;
      this.$message.info("更新中")
      
      schedulingEditShowLevelApi(
          this.id,
          this.showlevel,
          this.bindUsers,
          this.bindPartys,
          this.bindUnits
        )
        .then((r)=>{

          this.$message.success("更新成功")
          this.init();
        })
        .finally(()=>{
          this.loading = false;
        })
      
    }
  },
  watch:{
    showlevel(oldVal,newVal){

    }
  },
  
  computed:{
    hasAddressData(){
      if(!this.address){
          return false;
      }

      if(!this.lat && !this.lng){
        return false;
      }

      return true;
    },

    levelOptions(){
      let options = new Array();

      if(this.isAdmin || this.isSystemManager || this.isjdx){
            options.push({
              "id":0,
              "title":"全部"
            });

            if(this.type == 1){
              if(this.studyClassType == 0){
                options.push({
                  "id":2,
                  "title":"指定支部"
                });
              }
              else {
                options.push({
                  "id":1,
                  "title":"指定单位"
                });
              }
            }

            if(this.type == 2){
              options.push({
                "id":1,
                "title":"指定单位"
              });
            }

            if(this.type == 3){
              options.push({
                "id":2,
                "title":"指定支部"
              });
            }

            options.push({
              "id":3,
              "title":"指定人员"
            });
        }

        else if (this.isUnitManager){
            options.push({
              "id":1,
              "title":"本单位"
            });

            options.push({
              "id":3,
              "title":"指定人员"
            });
        }
        else {
            options.push({
              "id":2,
              "title":"本支部"
            });

            options.push({
              "id":3,
              "title":"指定人员"
            });
        }

        return options;
    },

    isSystemManager(){
      return this.roleid == "00001";
    },

    isUnitManager(){
      return this.roleid == "00003";
    },

    isPartyManager(){
      return this.roleid == "00002";
    },

    /**
     * 显示单位选项
     * 
     *  要素：
     *  1. 可见等级为单位
     * 
     *  2. *可见等级选择 指定人员
     *  2.1. 使用人员为人事管理员
     *  2.2. 使用人员为管理员，并且选择了 默认单位
     *  2.3. 使用人员为管理员，并且选择了属于 单位的 学习班
     * 
     */  
    showUnitOptions(){
      var show = false;
    
      if(this.showlevel == 1){
        return true;
      }


      if(this.showlevel != 3){
          return false;
      }

      if(this.isUnitManager){
          return true;
      }

      if(this.isAdmin || this.isSystemManager || this.isjdx){
          return true;
      }
      return show;
    },


    /**
     * 显示党组织选项
     * 
     *  要素：
     *  1. 可见等级为党支部
     * 
     *  2. *可见等级选择 指定人员
     *  2.1. 使用人员为党支部管理员
     *  2.2. 使用人员为管理员，并且选择了 默认党支部
     *  2.3. 使用人员为管理员，并且选择了属于 党组织生活的 学习班
     * 
     */   
    showPartyOptions(){
      var show = false;
    
      if(this.showlevel == 2){
        return true;
      }


      if(this.showlevel != 3){
          return false;
      }

      if(this.isPartyManager){
          return true;
      }

      if(this.isAdmin || this.isSystemManager || this.isjdx){
        if(this.type == 3){
          return true;
        }

        if(this.type == 1){
          return true;
        }
      }
      return show;
    },
    isEdit(){
      return this.id != null;
    }
  },
  
  created() {
    this.isAdmin = this.$store.getters['profileModule/isadmin'];
    this.roleid = this.$store.getters['profileModule/roleid'];
    this.isjdx = this.$store.getters['profileModule/isjdx'];

  },
  mounted(){

    this.init();
  }
};
</script>

<style lang="scss" scoped>
.contBox {
  padding-left: 20px;
  & > div {
    & > span {
      width: 110px;
      font-size: 13px;
      color: #303133;
      margin-right: 25px;
      display: inline-block;
    }
  }
  .chooseBox {
    margin-bottom: 20px;
    display: flex;
    & > span {
      width: 150px;
      font-size: 13px;
      color: #303133;
      margin-right: 25px;
      display: inline-block;
    }
  }
  //   ::v-deep .el-cascader__tags {
  //     max-height: 300px;
  //     width: 100%;
  //     overflow: auto;
  //   }
  //   ::v-deep .el-cascader .el-input.is-focus .el-input__inner {
  //       max-height: 300px;
  //   }
}

.button_box{
  padding-left: 20px ;
  padding-bottom: 20px;
  padding-top: 10px;
}
</style>